import { render, staticRenderFns } from "./MarketSettingPenalty.vue?vue&type=template&id=87c9db6e&scoped=true"
import script from "./MarketSettingPenalty.vue?vue&type=script&lang=js"
export * from "./MarketSettingPenalty.vue?vue&type=script&lang=js"
import style0 from "./MarketSettingPenalty.vue?vue&type=style&index=0&id=87c9db6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c9db6e",
  null
  
)

export default component.exports